import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import { type AssetGroupDetails, ZAssetGroupDetails } from '../types'

const ZApiResponse = z.object({
  http_status: z.number(),
  data: z.optional(ZAssetGroupDetails),
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export type ApiResponse = z.infer<typeof ZApiResponse>

export async function getAssetGroupDetails (
  groupId: string,
  tenantId: string,
  onSuccess: (assetGroupDetails: AssetGroupDetails, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-service/api/v1/udp/groupManagement/assetGroup/${groupId}?tenantId=${tenantId}`

  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        // istanbul ignore else
        if (
          parseResponse.data.data !== null &&
          parseResponse.data.data !== undefined
        ) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        } else {
          onFailure(
            parseResponse.data.error_message,
            parseResponse.data.http_status
          )
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore else
      if (error.response !== undefined) {
        // istanbul ignore else
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.message, error.response.status)
        }
      } else {
        onFailure(error.message, error.status)
      }
    })
}
